// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__zWjEE","unreadBadge":"styles_unreadBadge__1_IJ2","modalContent":"styles_modalContent__3xcsG","modal":"styles_modal__Nx-ro"};